export const LOAN_CONTENTFUL_ACCESS_TOKEN = 'e4d03e82aaec79913788a6459c6d6796f1a7688988714c1c5687e6ace5d8b454';
